import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { h3, h4, paragraphMedium } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  position: relative;
`;
const Bg = styled.div `
  position: absolute;
  bottom: -80px;
  left: 0;
  width: 100%;
  height: 300px;
  background-color: ${brand.base.blue};
`;
const Header = styled.div `
  margin: 0 0 ${fluid(24, 40)};
  text-align: center;
  max-width: 60ch;
  margin-left: auto;
  margin-right: auto;

  @media ${until(Device.TabletLarge)} {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }

  @media ${from(Device.TabletLarge)} {
    display: flex;
    align-items: flex-end;
    column-gap: ${fluid(24, 40)};
    justify-content: center;
  }
`;
const ContentInner = styled.div `
  margin-top: ${fluid(0, 60)};
  padding-right: ${fluid(0, 60)};

  @media ${until(Device.TabletLarge)} {
    text-align: center;
    max-width: 60ch;
    margin-left: auto;
    margin-right: auto;
  }
`;
const Title = styled.div `
  ${h4}

  h1& {
    ${h3};
  }
`;
const Content = styled.p `
  ${paragraphMedium};

  font-size: ${fluid(16, 20)};
  line-height: ${fluid(26, 30)};
`;
const Body = styled.div `
  position: relative;

  @media ${until(Device.TabletLarge)} {
    row-gap: 8px;
  }
`;
const List = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;

  @media ${from(Device.TabletLarge)} {
    --cardWidth: 33%;

    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    &[data-columns='2'] {
      --cardWidth: 50%;

      max-width: 66%;
    }
  }
`;
const Item = styled.div `
  padding-bottom: 16px;
  scroll-snap-align: start;

  @media ${until(Device.TabletLarge)} {
    flex: 0 0 100%;
  }

  @media ${from(Device.TabletLarge)} {
    flex: 0 1 calc(var(--cardWidth) - 8px);
  }
`;
const CtaCardsStyles = {
    Bg,
    Body,
    Container,
    Content,
    ContentInner,
    Header,
    Item,
    List,
    Title,
};
export default CtaCardsStyles;
